
import { Sale } from 'src/core/models/'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  SaleStatusColumn,
  ProjectSaleColumn,
  SaleAmountColumn,
  CustomDateColumn,
  SaleListActions,
  SaleItemMovileViewColumn
} from 'src/components'

const saleListColumns: ColumnsType<Sale> = [
  {
    title: () => <CustomHeaderText text={'Summary.Status'} />,
    responsive: ['sm'],
    render: (_, sale) => <SaleStatusColumn sale={sale} />
  },
  {
    title: () => <CustomHeaderText text={'Offers.Project'} />,
    responsive: ['sm'],
    sorter: (a: Sale, b: Sale) => a.projectName.length - b.projectName.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, sale) => <ProjectSaleColumn sale={sale} />
  },
  {
    title: () => <CustomHeaderText text={'Summary.Amount'} />,
    responsive: ['sm'],
    sorter: (a: Sale, b: Sale) => a.amount - b.amount,
    sortDirections: ['descend', 'ascend'],
    render: (_, sale) => <SaleAmountColumn sale={sale} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Date' isCentered />,
    dataIndex: 'created',
    sorter: (a: Sale, b: Sale) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    responsive: ['sm'],
    render: (_, sale) => <CustomDateColumn dateValue={sale.created} />
  },
  {
    title: () => <CustomHeaderText text='general.Actions' isCentered />,
    responsive: ['sm'],
    render: (_, sale) => <SaleListActions sale={sale} />
  },

  // Mobile
  {
    title: () => <CustomHeaderText text={'Transactions.MySales'} />,
    responsive: ['xs'],
    sorter: (a: Sale, b: Sale) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, sale) => <SaleItemMovileViewColumn sale={sale} />
  }
]

export default saleListColumns
